<template>
    <div class="modalitem-search">
        <b-form>
            <b-row>
              <b-col md="8" sm="12">
                    <b-form-group   
                        label="Descrição:" 
                        label-for="entity-name_equipment">
                    <b-form-input 
                        id="entity-name_entity" 
                        type="text"
                        v-model="equipment.name_equipment"
                        size="sm"
                        :readonly= 'true'
                        placeholder="Nome..." />
                    </b-form-group>
                </b-col> 
                    <b-col md="4" sm="12">
                    <b-form-group 
                        label="Código Equipamento:" 
                        label-for="entity-internal_code_equipment">
                    <b-form-input 
                        id="entity-internal_code_equipment" 
                        type="text"
                        v-model="equipment.internal_code_equipment"
                        size="sm"
                        :readonly= 'true'
                        placeholder="" />
                    </b-form-group>
                </b-col>  
            </b-row>
            <b-row>
                <div class="col-sm-8">
                    <div class="form-group">
                        <label 
                            class="control-label"> 
                            <i class="fa fa-search">
                            </i>  Pesquisar 
                        </label> 
                        <b-button 
                            pill 
                            size="sm" 
                            class=" ml-2 mb-2 fa fa-search" 
                            @click="[loadEquipments(),showTable = !showTable]" 
                            variant="outline-secondary" >
                        </b-button>
                        <input 
                            type="text" 
                            icon="search" 
                            autofocus
                            v-on:keyup.enter="[loadEquipments(),showTable = !showTable]"
                            v-model="searchEquipment" 
                            placeholder="Informe o nome" 
                            class="form-control">
                    </div>
                </div>
            </b-row>  
            <b-table 
                class="table-responsive" 
                :per-page="perPage" 
                :current-page="currentPage" 
                hover 
                striped 
                v-show="showTable" 
                :items="filteredListEquipment" 
                :fields="fieldsEquipment">
                <template slot="actions" slot-scope="data">
                        <b-button 
                            pill 
                            title = "Selecionar o registro" 
                            size="sm" 
                            variant="secondary" 
                            @click="[setSearchEquipament(data.item),showTable = !showTable]" 
                            class="mr-2 mt-2">
                            <i class="fa fa-check-square-o"></i>
                        </b-button>
                </template>   
            </b-table>
            <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
            ></b-pagination> 
        </b-form>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'

export default {
    name: 'EquipamentSearchModal',
    props:['equipament_id'],
    data: function() {
        return {
            searchEquipment: '',
            showTable: false,
            fieldsEquipment: [
                    { key: 'internal_code_equipment', label: 'Código Equipamento', sortable: false },
                    { key: 'name_equipment', label: 'Nome', sortable: true },
                    { key: 'name_entity', label: 'Razão Social', sortable: false },
                    { key: 'group_patrimonial_name', label: 'Grupo', sortable: false },
                    { key: 'name_cost_center', label: 'Centro Custo', sortable: false },
                    { key: 'blocked', label: 'Bloqueado', sortable: false,
                            formatter: value => value ? 'Sim' : 'Não' },               
                    { key: 'actions', label: 'Ações', variant: 'light'}
            ],
            perPage: 5,
            currentPage: 1,
            equipment:{},
            equipmentsshearch: [],
        }
    },
     computed: {
        compan(){
            return this.$store.state.compan
        },
         filteredListEquipment() {
          return this.equipmentsshearch.filter(equipment => {
             return (
                equipment.internal_code_equipment.toLowerCase().includes(this.searchEquipment.toLowerCase()) ||
                equipment.name_equipment.toLowerCase().includes(this.searchEquipment.toLowerCase())
                )
            })
        },rows() {
            return this.equipmentsshearch.length
        },
    },
    methods: {
            async loadEquipments() {
                const url = `${baseApiUrl}/equipmentsbycompany/${this.compan.id}`
                await axios.get(url).then(res => {
                    this.equipmentsshearch = res.data
                })
            },
             setSearchEquipament(equipament) {
              this.equipment.name_equipment = equipament.name_equipment
              this.equipment.internal_code_equipment = equipament.internal_code_equipment

              this.$emit('setEquipmentId',equipament.id)
              this.$emit('setEquipmentName',equipament.name_equipment)
              this.$emit('setEntityInternalCode',equipament.internal_code_equipment)
              this.$emit('setEquipmentTypeControlMaintenance',equipament.type_control_maintenance_id)
              this.$emit('setEquipmentControlMaintenanceCurrent',equipament.control_maintenance_current)
              this.$emit('setEquipmentCostCenter',equipament.equipment_cost_center_id)
              
            },
    },
    mounted() {
      
    }
}
</script>

<style>


    .modalitem-search select{
        font-size: 0.7rem;
    }
    .modalitem-search input{
        font-size: 0.7rem;
    }
    .modalitem-search button{
        font-size: 0.7rem;
    }
    .modalitem-search table{
        font-size: 0.7rem;
    }

    
    @keyframes slide-in {
    from {transform: translateY(40px);}
    to {transform: translateY(0);}
    }

    @keyframes slide-out {
        from {transform: translateY(0);}
        to {transform: translateY(40px);}
    }

    .slide-enter-active {
    animation: slide-in 1s ease;
        transition: opacity 1s;
    }

    .slide-leave-active {
        animation: slide-out 1s ease;
        transition: opacity 1s;
    }

    .slide-enter, .slide-leave-to{
        opacity: 0;
    }

    .fade-enter, .fade-leave-to{
    opacity: 0;
    }

    .fade-enter-active, .fade-leave-active{
    transition: opacity 1s;
}

</style>
